import { ref } from "vue";
import { getChatterList } from "@/api/chatterAPI";
import { transformChatterData } from "@/utils/chatterUtils";
import { TASK_CHATTER_TABLE } from "./tasksTableMapper";

function getCurrentAccountId() {
  try {
    return JSON.parse(localStorage.getItem("currentAccountID"));
  } catch {
    return localStorage.getItem("currentAccountID");
  }
}

function toSafeChatterResults(results) {
  return (Array.isArray(results) ? results : []).map((item) => ({
    ...item,
    recorded_by_name: item.recorded_by_name || "",
  }));
}

export function useTaskChatter() {
  const drawer = ref(false);
  const type = ref("Task");
  const typeValue = ref("");
  const listData = ref({});
  const chatterList = ref([]);
  const totalCheckpointChatter = ref(0);
  const page = ref(1);

  async function fetchChatter(task, nextPage, append) {
    const accountId = getCurrentAccountId();
    const recordId = task?.id;
    if (!accountId || recordId == null) {
      if (!append) {
        chatterList.value = [];
        totalCheckpointChatter.value = 0;
      }
      return;
    }

    try {
      const table = task.chatterTable || TASK_CHATTER_TABLE;
      const { data } = await getChatterList(accountId, recordId, table, nextPage);
      const mapped = transformChatterData(toSafeChatterResults(data?.results));
      chatterList.value = append ? [...chatterList.value, ...mapped] : mapped;
      totalCheckpointChatter.value =
        typeof data?.count === "number" ? data.count : chatterList.value.length;
      page.value = nextPage;
    } catch (error) {
      console.error("Failed to load task chatter:", error);
      if (!append) {
        chatterList.value = [];
        totalCheckpointChatter.value = 0;
      }
    }
  }

  async function openChatter(task) {
    listData.value = task || {};
    typeValue.value = task?.summary || "";
    chatterList.value = [];
    totalCheckpointChatter.value = 0;
    page.value = 1;
    drawer.value = true;
    await fetchChatter(task, 1, false);
  }

  function closeDrawer() {
    drawer.value = false;
    chatterList.value = [];
    totalCheckpointChatter.value = 0;
    page.value = 1;
    listData.value = {};
    typeValue.value = "";
  }

  async function requestMore() {
    if (chatterList.value.length >= totalCheckpointChatter.value) return;
    await fetchChatter(listData.value, page.value + 1, true);
  }

  return {
    drawer,
    type,
    typeValue,
    listData,
    chatterList,
    totalCheckpointChatter,
    openChatter,
    closeDrawer,
    requestMore,
  };
}
